import {
  CreateContextProvider,
  Form,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import LeaderboardCycleForm from './LeaderboardCycleForm';
import { createLeaderboardCycle } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import dayjs from 'dayjs';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const CreateLeaderboardCycle = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.redpacket,
    mutationOptions: {
      onSuccess: () => {
        notify('Created successfully', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'Creation failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        if (
          data.rewardAutoTransferEnabled &&
          data.rewardTransferTime &&
          data.endTime &&
          !dayjs(data.rewardTransferTime).isAfter(dayjs(data.endTime))
        ) {
          notify(t('module.redpacket.rewardTransferMustAfterEnd'), { type: 'warning' });
          return;
        }
        await createLeaderboardCycle({
          startTime: data.startTime,
          endTime: data.endTime,
          rewardAutoTransferEnabled: !!data.rewardAutoTransferEnabled,
          ...(data.rewardAutoTransferEnabled && data.rewardTransferTime
            ? { rewardTransferTime: data.rewardTransferTime }
            : {}),
        });
        notify('Created successfully', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'Creation failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  return (
    <CreateContextProvider value={controller}>
      <Form
        disableInvalidFormNotification
        defaultValues={{
          rewardAutoTransferEnabled: false,
          rewardTransferTime: '',
        }}
      >
        <DialogTitle>Create Leaderboard Cycle</DialogTitle>
        <DialogContent>
          <LeaderboardCycleForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="create">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateLeaderboardCycle;
